import { AUTH_FRONTEND_URL, GOOGLE_CLIENT_ID } from 'helpers/config'
import { RequesterType } from 'helpers/types'

export type TypeCreationApp = 'LOGIN' | 'SIGN_UP'

export type GoogleStateObject = {
  redirectUrl: string
  typeCreationApp: TypeCreationApp
  productId?: string
  requester?: RequesterType
  overrideDefaultSignupAction?: string
}

type Options = {
  onlyBusinessDomain?: boolean
}

const google = {
  connect: (state: GoogleStateObject, options: Options) => {
    const redirectUri = `${AUTH_FRONTEND_URL}/google`

    const scopes = ['https://www.googleapis.com/auth/userinfo.profile', 'https://www.googleapis.com/auth/userinfo.email']

    const searchParams = new URLSearchParams({
      access_type: 'offline',
      scope: scopes.join(' '),
      response_type: 'code',
      client_id: GOOGLE_CLIENT_ID,
      redirect_uri: redirectUri,
      state: JSON.stringify(state),
    })
    if (options.onlyBusinessDomain) searchParams.set('hd', '*')

    const url = `https://accounts.google.com/o/oauth2/v2/auth?${searchParams.toString()}`

    window.location.href = url
  },
}

export default google
